import React, { useState } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table,
    TableHead,
    TableBody,TableContainer,
      Paper,
    TableCell
} from "@material-ui/core";
import AddClassService from "./Locality/Service/addClassService";

import {  Card, Box } from "@material-ui/core";
import StudentService from "./Locality/Service/studentService"
import MovableService from "./Locality/Service/movablesService";
import * as Yup from 'yup';
import TablePagination from '@material-ui/core/TablePagination';
import { Grid, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useEffect } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function Movable() {

//  const tableHeaders = ["Student Name",
//     'Vowel-1', 'Vowel-2',	'Vowel-3',	'j', 'e', 'sh',	'ch', 'th',	'ng', 'oo',  'ee',	'oo', 'a-e', 'i-e',	'o-e', 	'u-e (1)',	'u-e (2)', 'le',
//     	'qu',	'ssggll',	'Hp -vowel', 'Hp-Const', 'Hg-Vowel', 'Hg-Const'
// ];
// const movable = [
//     'Vowel-1', 'Vowel-2',	'Vowel-3',	'j', 'e', 'sh',	'ch', 'th',	'ng', 'oo',  'ee',	'oo', 'a-e', 'i-e',	'o-e', 	'u-e (1)',	'u-e (2)', 'le',
//     	'qu',	'ssggll',	'Hp -vowel', 'Hp-Const', 'Hg-Vowel', 'Hg-Const'
//   ];

    const classes = useStyles();
    const [movable ,setmovable] =  useState([]);
    const [tableHeaders, setTableHeaders] = useState([]);
    const [studentList, setStudentList] = useState([]);
    const [addClassList, setAddClassList] = useState([]);
    const [movableList, setMovableList] = useState([]);
    const [formData, setFormData] = useState("");
    const [age, setAge] = React.useState('');
    var [error, setError] = useState(null);
    var [uploadError, setUploadError] = useState({ isShowError: false, successCount: 0, error: [], message: "" });
    const [open, setOpen] = React.useState(false);
    const [open1, setOpen1] = React.useState(false);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(5);
    const current = new Date();
    var [classId, setClassId] = useState("");
    const date = `${current.getFullYear()}-0${current.getMonth() + 1}-${current.getDate()}`;
    var [dateValue, setDateValue] = useState(date);
    // const [movable, setMovable] = useState({
    //     classId:'',
    //     movable: '',
      
    //     studentId: '',
    // });
 
    const validationSchema = Yup.object().shape({
        classId: Yup.string().required('Class Name is required'),
        studentId: Yup.string().required('Student Name is required'),
        movable: Yup.string().required('movable is required'),
    });
    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    }
    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }
    useEffect(() => {
        getStudentList();
        return () => {
            setStudentList([]);
        }
    }, []);
    const getMovableList = () => {
        MovableService.getAllMovable().then((res) => {
            setMovableList(res);
        }).catch((err) => {
            setError(err.message);
        });
    }
    const handleOpen = () => {
        setOpen(true);
    };
    const handleOpen1 = () => {
        setOpen1(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleClose1 = () => {
        setOpen1(false);
    };
    const getAddClassList = (event) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            if(userDetails.role==="TEACHER"){
                res =   res.filter(res=>res._id=== userDetails.classId); 
            }
            setAddClassList(res);
            if (userDetails.classId) {
                setClassId(userDetails.classId);
                getStudentList({ target: { value: userDetails.classId } });
              } else {
                setClassId(""); // No default selection
              }
        }).catch((err) => {
            // setError(err.message);
        });
    }
    

    // const deleteSpecialObservation = (observationdelete) => {
    //     if (observationdelete) {
    //         SpecialObservationService.deleteSpecialobservation(observationdelete).then((res) => {
    //             getSpecialObservationList();
    //         }).catch((err) => {
    //         });
    //     }
    // };
 
    const deleteMovable = (movabledelete) => {
        if (movabledelete) {
            MovableService.deleteMovable(movabledelete).then((res) => {

               getMovableList()
            }).catch((err) => {
            });
        }
    }
    const handleChangeImage = (evt) => {
        console.log("Uploading");
        var file = evt.target.files[0];
        let data = new FormData();
        data.append('image', file);
        setFormData(data)
        console.log("Uploaded");
    }

    const getStudentList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getSpeList = {   classId: userDetails.classId};
        StudentService.getAllStudentById(userDetails.schooleId,
            getSpeList
        ).then((res) => {
            const studentDetails = res.map((student) => {
                // Ensure each student has a sounds object; initialize if missing
                const movablesObj = student.movable || {};
                const keys = Object.keys(movablesObj);
                setmovable(keys);
                setTableHeaders([...["Student Name"],...keys]);
                keys.forEach((movable) => {
                  if (!(movable in movablesObj)) {
                    movablesObj[movable] = false; // Initialize sound as unchecked
                  }
                });
                return {
                  _id: student._id,
                  studentName: `${student.firstName} ${student.lastName}`,
                  movable: movablesObj,
                };
              });
              
              setStudentList(studentDetails);

        }).catch((err) => {
            // setError(err.message);
        });
    }

    const formik = useFormik({
        initialValues: {},
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            if (movable._id) {
                MovableService.upadeMovable(values).then((res) => {
                    handleClose();
                    getMovableList();
                    resetForm()
                    alert(" Movable Alphabets Updated Successfully.");
                }).catch((err) => {
                });
            }
            else {
                
                MovableService.creteMovable(values).then((res) => {
                    getMovableList();
                    resetForm();
                    handleClose();
                    alert(" Movable Alphabets Added Successfully.");
                })
                    .catch((err) => {
                        alert(err.response.data.message)
                    })
            }

        },
    });
    const handleCheck = (student, movableKey) => {
        
        // Update the student's sound locally
        const updatedStudent = {
          ...student,
          movable: {
            ...student.movable,
            [movableKey]: !student.movable[movableKey],
          },
        };
        
        // Update the student list state
        const updatedList = studentList.map((s) =>
          s._id === student._id ? updatedStudent : s
        );
        setStudentList(updatedList);
    
        // Call API to update the student
        StudentService.upadeStudent(updatedStudent)
          .then((res) => {
            // Optionally refresh the student list if the API response provides updated data
           // getStudentList();
          })
          .catch((err) => {
            console.error(err.response?.data?.message || "Error updating student");
          });
      };
    
    const onSubmit = data => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const keys = {  "schooleId": userDetails.schooleId, "studentList": studentList, "teacherId": userDetails._id,
         "date": dateValue
         }
         MovableService.creteMovable(keys).then((res) => {
            setDateValue("");
            setStudentList([]);
            alert(" Attendence Successfully.");
        }).catch((err) => {

            alert(err.response.data.message);
        });
    };
    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={10}>
                    <PageTitle title="Movable Alphabets " 
                    />

                </Grid>
                
            </Grid>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                                                <TableContainer component={Paper} style={{ maxHeight: 500 }}>
                        
                       <Table stickyHeader className="mb-0">
                                     <TableHead>
                                       <TableRow>
                                         {tableHeaders.map((key) => (
                                           <StyledTableCell key={key}>{key}</StyledTableCell>
                                         ))}
                                       </TableRow>
                                     </TableHead>
                                     <TableBody>
                                       {studentList
                                         .slice(pg * rpg, pg * rpg + rpg)
                                         .map((student) => (
                                           <TableRow key={student._id}>
                                             <TableCell className="pl-3 fw-normal">
                                               {student.studentName}
                                             </TableCell>
                                             {movable.map((movableKey) => (
                                               <TableCell key={movableKey} className="pl-3 fw-normal">
                                                 <input
                                                   type="checkbox"
                                                   checked={student.movable[movableKey] || false}
                                                   style={{ height: "15px", width: "15px" }}
                                                   onChange={() => handleCheck(student, movableKey)}
                                                 />
                                               
                                               </TableCell>
                                             ))}
                                           </TableRow>
                                         ))}
                                     </TableBody>
                                   </Table>
                                                                                   </TableContainer >

                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[5, 50, 100, 500, 1000]}
                            count={studentList.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
           
        </>

    );
}


